import React from 'react'

import {
  BigCalendarAvailabilityGlobalCell,
  BigCalendarOptionsGlobalCell,
} from './components/BigCalendarCellsGlobal'
import {
  HouseAvailabilityGlobalOutputDto,
  HouseAvailabilityICalendarOutputDto,
} from '../../../../../../../lib/graphql'
import { HouseContextGlobal } from '../../../../helpers/assert-house-price-type'
import { BigCalendarICalendarCell } from '../../../shared/calendar/components/cell/icalendar/BigCalendarICalendarCell'

export type BigCalendarCellGlobalProps = {
  house: HouseContextGlobal
  availability:
    | null
    | HouseAvailabilityGlobalOutputDto
    | HouseAvailabilityICalendarOutputDto
  cellDate: Date
}
export const BigCalendarCellGlobal = ({
  house,
  availability,
  cellDate,
}: BigCalendarCellGlobalProps) => {
  return (
    <>
      {availability ? (
        <>
          {availability.__typename === 'HouseAvailabilityICalendarOutputDto' ? (
            <BigCalendarICalendarCell />
          ) : availability.__typename === 'HouseAvailabilityGlobalOutputDto' ? (
            <BigCalendarAvailabilityGlobalCell
              availability={availability}
              house={house}
            />
          ) : null}
        </>
      ) : (
        <BigCalendarOptionsGlobalCell house={house} cellDate={cellDate} />
      )}
    </>
  )
}
